import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../components/InputField";
import Button from "../components/Button";
import BackButton from "../components/BackButton";
import { Modal } from "react-bootstrap";
import api from "../api/api";
 
const validationSchema = Yup.object({
   warehouse_name: Yup.string().required("Warehouse name is required"),
   location_city: Yup.string().required("Location/City is required"),
   base_rate: Yup.number()
     .required("Base rate is required")
     .typeError("Must be a number"),
   address1: Yup.string().required("Address Line 1 is required"),
   address2: Yup.string().required("Address Line 2 is required"),
   pincode: Yup.string()
     .required("Pincode is required")
     .matches(/^[0-9]{6}$/, "Invalid pincode"),

   manager_name: Yup.string().required("Manager name is required"),
   manager_email: Yup.string()
     .email("Invalid email")
     .required("Email is required"),
   manager_contact: Yup.string()
     .matches(/^[0-9]{10}$/, "Contact number must be 10 digits")
     .required("Contact number is required"),
 });
 
const CreateWarehouse = () => {
   const navigate = useNavigate();
   const [showConfirm, setShowConfirm] = useState(false);
   const [showSuccess, setShowSuccess] = useState(false);
   const [formValues, setFormValues] = useState(null);
 
  const handleSubmit = (values, { setSubmitting }) => {
    setFormValues(values);
    setSubmitting(false);
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setShowConfirm(false);
    try {
      await api.post("/wh-owner/warehouse/request-create", formValues);
      setShowSuccess(true);
    } catch (error) {
      alert("Failed to submit request!");
      console.error(error);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate("/my-warehouses");
  };
 
  return (
    <>
      <BackButton />
 
      <div className="container mt-3">
        <Formik
          initialValues={{
            warehouse_name: "",
            location_city: "",
            base_rate: "",
            address1: "",
            address2: "",
            pincode: "",
            manager_name: "",
            manager_email: "",
            manager_contact: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, handleChange }) => (
            <Form>
              {/* Warehouse Details */}
              <div className="card shadow-sm mb-4">
                <div
                  className="card-header"
                  style={{ background: "#1d3160", color: "#fff" }}
                >
                  Warehouse Details
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <InputField
                        label="Warehouse Name"
                        name="warehouse_name"
                        placeholder="Enter Warehouse Name"
                        value={values.warehouse_name}
                        onChange={handleChange}
                        error={errors.warehouse_name}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        label="Location/City"
                        name="location_city"
                        placeholder="Enter Location/City"
                        value={values.location_city}
                        onChange={handleChange}
                        error={errors.location_city}
                      />
                    </div>

                    <div className="col-md-3">
                      <InputField
                        label="Base Rate"
                        type="number"
                        placeholder="Enter Base Rate"
                        name="base_rate"
                        value={values.base_rate}
                        onChange={handleChange}
                        error={errors.base_rate}
                      />
                    </div>

                    <div className="col-md-3">
                      <InputField
                        label="Pincode"
                        name="pincode"
                        placeholder="Enter Pincode"
                        value={values.pincode}
                        onChange={handleChange}
                        error={errors.pincode}
                      />
                    </div>
 
                    <div className="col-md-6">
                      <InputField
                        label="Address Line 1"
                        name="address1"
                        placeholder="Enter Address1"
                        value={values.address1}
                        onChange={handleChange}
                        error={errors.address1}
                      />
                    </div>
 
                    <div className="col-md-6">
                      <InputField
                        label="Address Line 2"
                        name="address2"
                        placeholder="Enter Address2"
                        value={values.address2}
                        onChange={handleChange}
                        error={errors.address2}
                      />
                    </div>
                  </div>
                </div>
              </div>
 
              {/* Manager Details */}
              <div className="card shadow-sm mb-4">
                <div
                  className="card-header"
                  style={{ background: "#1d3160", color: "#fff" }}
                >
                  Warehouse Manager Details
                </div>
 
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <InputField
                        label="Manager Name"
                        name="manager_name"
                        placeholder="Enter Manager Name"
                        value={values.manager_name}
                        onChange={handleChange}
                        error={errors.manager_name}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Manager Email"
                        name="manager_email"
                        placeholder="Enter Manager Email"
                        value={values.manager_email}
                        onChange={handleChange}
                        error={errors.manager_email}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Manager Contact"
                        name="manager_contact"
                        placeholder="Enter Contact Number"
                        value={values.manager_contact}
                        onChange={handleChange}
                        error={errors.manager_contact}
                      />
                    </div>
                  </div>
                </div>
              </div>
 
              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="darkblue"
                  btncls="px-4"
                  type="submit"
                  text="Create"
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {/* Confirm Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to submit this warehouse request?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={() => handleConfirm()} />
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Warehouse request submitted successfully. Pending admin approval.</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateWarehouse;
 